import { render, staticRenderFns } from "./customerQuotationEditV2.vue?vue&type=template&id=248d3c15&scoped=true"
import script from "./customerQuotationEditV2.vue?vue&type=script&lang=js"
export * from "./customerQuotationEditV2.vue?vue&type=script&lang=js"
import style0 from "./customerQuotationEditV2.vue?vue&type=style&index=0&id=248d3c15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248d3c15",
  null
  
)

export default component.exports